'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var request = require('./request');
var axios = require('axios');

function recursiveParamsAddingToBuilderMake(builder, paramsArr, map) {
    var usedMethods = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var methodsTypes = arguments[5];

    var builderMethods = paramsArr;
    builder.prototype.get = request.send;
    builder.prototype.cancel = request.cancel;
    builderMethods.forEach(function (methodName) {
        builder.prototype[methodName] = function (value) {
            if (this.methodsUsed.includes(methodName)) {
                console.warn('You have already set ' + methodName + ' parameter  ');
            } else {
                if (methodsTypes.hasOwnProperty(map[methodName]) && methodsTypes[map[methodName]] !== (typeof value === 'undefined' ? 'undefined' : _typeof(value))) {
                    console.warn('Type error, method ' + methodName + ' expect data with ' + methodsTypes[map[methodName]] + ' type');
                }
                value && this.methodsUsed.push(methodName);
                value && (this.requestParams[map[methodName]] = value);
                this.defaultParams = Object.assign({}, this.requestParams);
            }
            return this;
        };
        builder.prototype[methodName].get = request.send;
        builder.prototype.cancel = request.cancel;
        usedMethods = [methodName].concat(usedMethods);
        builderMethods.length > 1 && recursiveParamsAddingToBuilderMake(builder, builderMethods.filter(function (name) {
            return !usedMethods.includes(name);
        }), map, builderMethods, level + 1, methodsTypes);
    });
    builder.prototype.useAnotherUrl = function (url) {
        this.url = url;
        return this;
    };
    builder.prototype.useParams = function (params) {
        Object.assign(this.requestParams, params);
        return this;
    };
    return builder;
}

module.exports = function (info, defaultParams, baseUrl, requestAuth, headers) {
    var requestBuilder = function requestBuilder() {
        if (requestAuth && requestAuth.username && requestAuth.password) {
            axios.defaults.auth = requestAuth;
        }
        this.mainMethodName = info.builderMethodName;
        this.requestType = info.requestType;
        this.formDataUsage = info.formDataUsage;
        this.defaultParams = Object.assign({}, defaultParams);
        this.requestParams = Object.assign({}, defaultParams);
        this.methodsUsed = [];
        this.builderParamWithRequestParamsMap = info.builderParamWithRequestParamsMap;
        this.requiredMethods = info.requiredBuilderParams;
        this.url = baseUrl + info.url;
        this.cancelToken = axios.CancelToken;
        this.useParser = info.useParser;
        this.cancelSource = null;
        this.headers = headers;
        return this;
    };
    recursiveParamsAddingToBuilderMake(requestBuilder, info.builderParams, info.builderParamWithRequestParamsMap, [], 1, info.methodTypeMap);

    return new requestBuilder();
};